export default "__VITE_ASSET__DVOgxu7w__"